import type { Disposable } from "./AsyncPool";
import { LimitedPool } from "./LimitedPool";

interface Options<Item> {
    size: number;
    fabric: () => Item;
}

export class FixedPool<Item extends Disposable> {
    private readonly pool: LimitedPool<Item>;

    public constructor({ size, fabric }: Options<Item>) {
        this.pool = new LimitedPool({ min: size, max: size, size: size, fabric: fabric });
        this.exec = this.pool.exec.bind(this.pool);
        this.dispose = this.pool.dispose.bind(this.pool);
    }

    /** Прокси на {@link LimitedPool.exec} */
    public exec: LimitedPool<Item>["exec"];

    /** Прокси на {@link LimitedPool.dispose} */
    public dispose: LimitedPool<Item>["dispose"];
}
